import { StandardFormatterId } from '../../util/formatter-service';

/**
 * Headline currency figures — the SOI KPI cards and the financing history table.
 * Its own id so a client can retune these two surfaces without moving the ~130
 * other values `currencyShort` renders app-wide.
 */
export const headlineCurrencyFormatterId: StandardFormatterId = 'currencyShort';
